import { Link } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/Editorial";

const NODES = [
  { to: "/livres", title: "Écriture", d: "Une bibliographie qui traverse les genres.", img: IMG.booksShelf, span: "md:col-span-2 md:row-span-2" },
  { to: "/histoire-esoterisme", title: "Histoire & Ésotérisme", d: "Comprendre d'où viennent les pratiques.", img: IMG.map },
  { to: "/mediumnite", title: "Médiumnité", d: "Une démarche nuancée et respectueuse.", img: IMG.candle },
  { to: "/deuil", title: "Deuil", d: "L'absence, le lien, la mémoire.", img: IMG.highlands },
  { to: "/onirotherapie", title: "Rêves", d: "Le langage symbolique de l'inconscient.", img: IMG.libraryCandle },
  { to: "/conferences", title: "Conférences", d: "Raconter l'invisible en public.", img: IMG.conference1 },
  { to: "/les-chroniques-de-letrange", title: "Les Chroniques", d: "L'histoire de l'étrange, documentée.", img: IMG.gothic, span: "md:col-span-2" },
];

export default function Univers() {
  useSeo({
    title: "L'Univers de Dorothée Lancelot",
    description: "Un nom, plusieurs univers : écriture, histoire, ésotérisme, deuil, rêves, médiumnité et conférences — tout ce qui relie le travail de Dorothée Lancelot.",
    path: "/univers",
  });

  return (
    <div>
      <PageHeader
        eyebrow="Vue d'ensemble"
        title="Un nom, plusieurs univers"
        intro="Écriture, histoire, ésotérisme, deuil, rêves, médiumnité et conférences : des univers qui se répondent, à la croisée de la recherche et de la transmission."
        image={IMG.libraryCandle}
        tall
      />
      <section className="dl-container py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[190px] gap-5">
          {NODES.map((n) => (
            <Link key={n.to} to={n.to} className={`dl-card group relative overflow-hidden flex flex-col justify-end p-7 ${n.span || ""}`}>
              <img src={n.img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-45 transition-opacity duration-500" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1020] via-[#0B1020]/60 to-transparent" />
              <div className="relative z-10">
                <h3 className="serif text-2xl md:text-3xl text-[#F3E9D2] group-hover:text-[#D4B978] transition-colors">{n.title}</h3>
                <p className="text-sm text-[#F3E9D2]/65 mt-1">{n.d}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
